if (typeof window.questionser === 'undefined') { let questionser = document.querySelectorAll(".questionser"); }

if (typeof window.questionser !== 'undefined') {
  questionser.forEach(questionser => {
    questionser.addEventListener("click", event => {
      const active = document.querySelector(".questionser.active");
      if (active && active !== questionser) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionser.classList.toggle("active");
      const answerser = questionser.nextElementSibling;
      if (questionser.classList.contains("active")) {
        answerser.style.maxHeight = answerser.scrollHeight + "px";
      } else {
        answerser.style.maxHeight = 0;
      }
    })
  })
}


// Globaal op window zetten
if (typeof window.drawerToggle === 'undefined') {
    window.drawerToggle = document.getElementById('drawerToggle');
}
if (typeof window.drawer === 'undefined') {
    window.drawer = document.getElementById('drawer');
}
if (typeof window.closeDrawer === 'undefined') {
    window.closeDrawer = document.getElementById('closeDrawer');
}
if (typeof window.overlay === 'undefined') {
    window.overlay = document.getElementById('overlay');
}

// gebruik de globale references
window.drawerToggle.addEventListener('click', () => {
    window.drawer.classList.add('open');
    window.overlay.classList.add('show');
});

window.closeDrawer.addEventListener('click', () => {
    window.drawer.classList.remove('open');
    window.overlay.classList.remove('show');
});

if (window.overlay) {
    window.overlay.addEventListener('click', () => {
        window.drawer.classList.remove('open');
        window.overlay.classList.remove('show');
    });
}
